globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.blog = appVisitor.blog || {};

appVisitor.blog.commentsController = (function() {
  function CommentsController($html) {
    this.$html                 = $html;
    this.$form                 = this.$html.find('.blog-article-new-comment form');
    this.$commentsList         = this.$html.find('.comments-list');
    if (this.$form.length >= 1) {
      this.loader              = new appVisitor.LoadingLoader(this.$form);
    }
  }

  CommentsController.prototype = {
    init: function() {
      this.initEvents();
    },

    initEvents: function() {
      var me = this;

      me.$html.on('submit', '.blog-article-new-comment form', function (e) {
        e.preventDefault();
        var $form = $(this);

        me.loader.loading();

        $.ajax({
          type: "POST",
          url: $form.attr('action'),
          data: $form.serialize(),
          success: function(data)
          {
            if (data.response == 1) {
              me.loader.finish();
              var $callbackMsg = me.$html.find('.sb-vi-ajax-callback.success');
              $callbackMsg.fadeIn(200);
              if (data.views !== undefined && data.views.commentThumbnail !== undefined) {
                me.$commentsList.before(data.views.commentThumbnail);
              }
            } else {
              me.loader.finish();
              $.each(data.errors, function(key, value) {
                var $error = $('<p class="error">' + value[0] + '</p>');
                $error.prependTo(me.$form);
              });
            };
          }
        });

        this.reset();
      });

      me.$html.on('click', '.see-all-comments', function (e) {
        $(this).fadeOut(200);
        me.$html.find('.hidden-comment').fadeIn(200);
      });

      me.$html.on('click', '.post-comment-btn', function (e) {
        me.$html.find('.blog-article-new-comment').fadeIn('fast');
        me.$html.find('.sb-vi-form-input').first().focus();
      });

    }
  };

  return CommentsController;
})();
